module.exports = __webpack_public_path__ + "@/assets/img/037-girl-20.31458c10.svg";